"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_capitalize_1 = __importDefault(require("lodash.capitalize"));

function capitalize(text) {
  if (typeof text !== 'string') {
    return '';
  }

  return lodash_capitalize_1.default(text);
}

exports.capitalize = capitalize;